const EndToEndRelocatedSolution = () => {
    return (
      <div>
    
      <div className="flex flex-col justify-center  gap-1 max-w-[50rem] mx-auto pl-[2rem] pr-[2rem] pt-[1rem]">
        <h1 className="text-[20px] font-bold">End-to-End Relocation</h1>
        <p>
          We offer an end-to-end solution for within the city and inter-city relocation, especially 
          beneficial for businesses and offices of any type and/or size.
        </p>
        <p>
        Structurally planned for moving furniture, fixtures, stationery and office records, 
        this service is available in all major cities of Pakistan, for all small, medium and large enterprises.
        </p>
        <p>
        For movers from within Pakistan to any part of the world, Packing-only and 
        Shipping-only services are also available.
        </p>
  
       
      </div>
    </div>
    );
  };
  
  export default EndToEndRelocatedSolution;
  